import React, {useState, useEffect} from 'react';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { t } from 'i18next';
import Room from './room-props-component';

import sideFiltersJSON from './side-filters.json';


const filter = (filters) => {
    return filters.map(filter => (
        <li key={filter.id}>
            <label>
                <input type="checkbox" id={filter.id} name={filter.id} />
                {t(filter.label)}
            </label>
        </li>
    ));
}

const group = (group) => {
    return (
        <div className="filter-group">
            <h6>{t(group.tag)}</h6>
            <ul>
                {filter(group.list)}
            </ul>
        </div>
    );
}


const SideFilters = () => {
    //https://docs.google.com/document/d/1xZP1xBHC1mutR1dng_jeMYBLRRu7wq530d1wsAtQ6-8/edit?tab=t.0
    return (
        <div className="side-filters">
           {sideFiltersJSON.map(group)}
        </div>
    );
}

export default SideFilters;
